/*
 * Product reels carousel behavior:
 *  - each video autoplays MUTED + looped only while visible (IntersectionObserver),
 *    pausing off-screen so 7 videos never decode at once;
 *  - the strip gently auto-scrolls one card at a time (setting-controlled),
 *    pausing while the user hovers, touches, or manually scrolls it;
 *  - tapping a card opens a fullscreen lightbox playing WITH sound.
 */
(function () {
  function init(root) {
    if (root.dataset.prInit === '1') return;
    root.dataset.prInit = '1';

    var track = root.querySelector('[data-pr-track]');
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-pr-video]'));
    if (!track || !videos.length) return;

    // ---- visibility-driven muted autoplay ----
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && e.intersectionRatio >= 0.35) {
            v.muted = true; // required for autoplay policies
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      },
      { threshold: [0, 0.35] }
    );
    // Pre-buffer ahead of playback: once a card is within ~600px of the
    // viewport, upgrade preload so the first frames are already downloaded
    // by the time the play-observer fires — kills the visible startup lag.
    var preloadIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.preload = 'auto';
            preloadIo.unobserve(e.target);
          }
        });
      },
      { rootMargin: '600px' }
    );
    videos.forEach(function (v) {
      io.observe(v);
      preloadIo.observe(v);
    });

    // ---- arrows ----
    var prev = root.querySelector('[data-pr-prev]');
    var next = root.querySelector('[data-pr-next]');

    function cardStep() {
      var item = track.querySelector('.product-reels__item');
      return item ? item.getBoundingClientRect().width + 10 : 160;
    }
    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.hidden = track.scrollLeft <= 2;
      next.hidden = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { userPaused(); track.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { userPaused(); track.scrollBy({ left: cardStep(), behavior: 'smooth' }); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    // ---- auto-scroll ----
    var enabled = root.dataset.autoscroll === 'true';
    var interval = (parseInt(root.dataset.interval, 10) || 4) * 1000;
    var pausedUntil = 0;
    var timer = null;

    function userPaused() {
      pausedUntil = Date.now() + 9000; // resume ~9s after last interaction
    }

    function tick() {
      if (document.hidden || Date.now() < pausedUntil) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      if (max <= 0) return;
      if (track.scrollLeft >= max) {
        track.scrollTo({ left: 0, behavior: 'smooth' }); // loop back to start
      } else {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      }
    }

    if (enabled) {
      timer = setInterval(tick, interval);
      root.addEventListener('mouseenter', userPaused);
      root.addEventListener('touchstart', userPaused, { passive: true });
      track.addEventListener('wheel', userPaused, { passive: true });
    }

    // ---- fullscreen lightbox with sound ----
    var lightbox = document.querySelector('[data-pr-lightbox]');
    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'pr-lightbox';
      lightbox.setAttribute('data-pr-lightbox', '');
      lightbox.hidden = true;
      lightbox.innerHTML =
        '<button class="pr-lightbox__close" type="button" aria-label="Close">&times;</button>' +
        '<video controls playsinline></video>';
      document.body.appendChild(lightbox);

      function closeLb() {
        var lv = lightbox.querySelector('video');
        lv.pause();
        lv.removeAttribute('src');
        lv.load();
        lightbox.hidden = true;
        document.documentElement.style.overflow = '';
      }
      lightbox.querySelector('.pr-lightbox__close').addEventListener('click', closeLb);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLb();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lightbox.hidden) closeLb();
      });
    }

    root.querySelectorAll('[data-pr-expand]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        userPaused();
        var card = btn.closest('[data-pr-card]');
        var v = card && card.querySelector('video');
        if (!v) return;
        // Pick the best mp4 source (highest listed <= 1080p, or the lone src).
        var src = v.currentSrc;
        var sources = card.querySelectorAll('source');
        if (sources.length) {
          var best = null;
          sources.forEach(function (s) {
            var h = parseInt(s.dataset.h || '0', 10);
            if (!best || (h > parseInt(best.dataset.h || '0', 10) && h <= 1080)) best = s;
          });
          if (best) src = best.getAttribute('src');
        }
        var lv = lightbox.querySelector('video');
        // Cards deliberately stream the light 480p rendition; fullscreen
        // deserves better. Shopify CDN renditions differ only by suffix, so
        // upgrade to 720p and fall back to the original if it 404s.
        var hd = src.replace('SD-480p-1.5Mbps', 'HD-720p-4.5Mbps');
        lv.onerror = function () {
          if (lv.src !== src) {
            lv.onerror = null;
            lv.src = src;
            lv.play().catch(function () {});
          }
        };
        lv.src = hd;
        lv.muted = false;
        lightbox.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var p = lv.play();
        if (p && p.catch) p.catch(function () {});
      });
    });

    // Cleanup on section unload in the theme editor.
    document.addEventListener('shopify:section:unload', function () {
      if (timer) clearInterval(timer);
      io.disconnect();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-reels]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
